import { actionGenerator } from '@mopla/utils';

export enum UserActionTypes {
	FetchUser = '[User] Fetch User',
	FetchUserResult = '[User] Fetch User Result',
	SaveUserLanguage = '[User] Save user language',
	SaveUserLanguageResult = '[User] Save user language result',
	InquiryInvoice = '[User] Inquiry Invoice',
	InquiryInvoiceResult = '[User] Inquiry Invoice Result',
	CheckBannedEmail = '[User] Check Banned Email',
	CheckBannedEmailResult = '[User] Check Banned Email Result',

	SignOut = '[User] Sign Out',
	SignOutResult = '[User] Sign Out Result',

	DeleteCurrentUser = '[User] Delete Current User',
	DeleteCurrentUserResult = '[User] Delete Current User Result',
}

export const fetchUser = actionGenerator<UserActionTypes.FetchUser>(
	UserActionTypes.FetchUser
);

interface ISaveUserLanguageActionPayload {
	language: string;
}

export const saveUserLanguageAction = actionGenerator<
	UserActionTypes.SaveUserLanguage,
	ISaveUserLanguageActionPayload
>(UserActionTypes.SaveUserLanguage);

export const saveUserLanguageResult =
	actionGenerator<UserActionTypes.SaveUserLanguageResult>(
		UserActionTypes.SaveUserLanguageResult
	);

export const fetchUserResult = actionGenerator<UserActionTypes.FetchUserResult>(
	UserActionTypes.FetchUserResult
);

interface IInquiryInvoicePayload {
	subscriptionId: string | null;
	month: number | null;
	year: number | null;
}

export const inquiryInvoice = actionGenerator<
	UserActionTypes.InquiryInvoice,
	IInquiryInvoicePayload
>(UserActionTypes.InquiryInvoice);

export const inquiryInvoiceResult =
	actionGenerator<UserActionTypes.InquiryInvoiceResult>(
		UserActionTypes.InquiryInvoiceResult
	);

export interface ICheckBannedEmailPayload {
	email: string;
}

export interface ICheckBannedEmailResultPayload {
	isValid: boolean;
}

export const checkBannedEmail = actionGenerator<
	UserActionTypes.CheckBannedEmail,
	ICheckBannedEmailPayload
>(UserActionTypes.CheckBannedEmail);

export const checkBannedEmailResult = actionGenerator<
	UserActionTypes.CheckBannedEmailResult,
	ICheckBannedEmailResultPayload
>(UserActionTypes.CheckBannedEmailResult);

export const signOut = actionGenerator<UserActionTypes.SignOut>(
	UserActionTypes.SignOut
);

export const signOutResult = actionGenerator<UserActionTypes.SignOutResult>(
	UserActionTypes.SignOutResult
);

export const deleteCurrentUser =
	actionGenerator<UserActionTypes.DeleteCurrentUser>(
		UserActionTypes.DeleteCurrentUser
	);

export const deleteCurrentUserResult =
	actionGenerator<UserActionTypes.DeleteCurrentUserResult>(
		UserActionTypes.DeleteCurrentUserResult
	);

export type TSaveUserLanguageAction = ReturnType<typeof saveUserLanguageAction>;
export type FetchUserAction = ReturnType<typeof fetchUser>;
export type TInquiryInvoiceAction = ReturnType<typeof inquiryInvoice>;
export type TCheckBannedEmailAction = ReturnType<typeof checkBannedEmail>;
export type TCheckBannedEmailResultAction = ReturnType<
	typeof checkBannedEmailResult
>;
